import TechnicalRepresentativeForm from './TechnicalRepresentativeForm';
export default TechnicalRepresentativeForm;